const paymentStatus = {
  bulkChequeImport: {
    title: "Importer des images de chèques",
    uploadDescription:
      "Le format d'archive accepté est ZIP uniquement. La taille maximale par fichier est de 500 Mo.",
    accept: ".zip",
    beforeUploading: "Avant de téléverser :",
    instruction1: "Assurez-vous que tous les fichiers de chèques sont dans un format accepté :",
    instruction1Sub:
      "PDF (.pdf), Images (.jpg, .jpeg, .png, .gif, .tiff), Word (.doc, .docx), Excel (.xls, .xlsx), Outlook (.msg)",
    instruction2: "Tous les fichiers respectent ce format de nom :",
    instruction2Example:
      "ex. : CAD_0001_NomDuCréancier.pdf, CAD_0001_NomDuCréancier.jpg, CAD_0001.msg",
    instruction3: "Placez tous les fichiers dans un seul fichier ZIP",
    instruction3Sub: "Les fichiers peuvent être organisés dans des dossiers si nécessaire",
    instruction4: "Ouvrez le fichier ZIP et confirmez que tous les fichiers acceptés sont inclus (dans des dossiers ou à la racine)",
  },
};

export default paymentStatus;
